/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

$(document).on("turbo:load", () => new window.App.Components.ytPlayerWithGaTracking())

window.App.Components.ytPlayerWithGaTracking = class ytPlayerWithGaTracking {
  constructor() {
    this.getPlayerPercentageViewed = this.getPlayerPercentageViewed.bind(this)
    this.debug = true
    this.bindElements()
    this.setupYoutubePlayer()
  }

  bindElements() {
    return $("body").on("translatePage", jqEvent => {
      const { originalEvent: e } = jqEvent
      const lang = e != null && e.detail != null && e.detail.lang

      if (!lang) {
        return
      }

      this.player.destroy()
      return this.loadPlayer({
        cc_lang_pref: lang,
        cc_load_policy: 1,
      })
    })
  }

  setupYoutubePlayer() {
    if (
      (typeof YT !== "undefined" && YT !== null ? YT.Player : undefined) != null
    ) {
      return this.loadPlayer()
    } else {
      window.onYouTubeIframeAPIReady = () => {
        return this.loadPlayer()
      }

      const hostUrl = "https://www.youtube.com/iframe_api"

      const tag = document.createElement("script")
      tag.src = hostUrl
      const firstScriptTag = document.getElementsByTagName("script")[0]
      return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }
  }

  loadPlayer(playerVars) {
    if (playerVars == null) {
      playerVars = {}
    }
    const data = $("#playerContainer").data()
    if (data != null) {
      const { lessonId } = data
      const { videoId } = data
      this.timelineMarker = 0
      this.videoPlaybackQuality = "medium"

      const playerDefaultVars = {
        rel: 0,
        enablejsapi: 1,
        modestbranding: 1,
        wmode: "transparent",
        start: data.videoStart,
        end: data.videoEnd,
      }

      const player = new YT.Player("playerContainer", {
        height: "360",
        width: "640",
        playerVars: $.extend({}, playerDefaultVars, playerVars),
        videoId,
        events: {
          onReady(event) {
            return new App.Components.YoutubeVideoSeekTo({
              player: event.target,
              selector: "[data-seek-to]",
            })
          },

          // we can get current time with player.getCurrentTime()
          onStateChange: event => {
            const lessonsAll = new App.lessonsAll()
            switch (event.data) {
              case YT.PlayerState.PLAYING:
                $(document).trigger("VideoPlayer::started", event.target)

                this.checkTimeline(true, event, videoId, lessonId)
                return lessonsAll.logView()
              case YT.PlayerState.PAUSED:
                this.checkTimeline(false, event)
                return $(document).trigger("VideoPlayer::paused", event.target)
              case YT.PlayerState.ENDED:
                if ($(".lessonsShowView").length !== 0) {
                  lessonsAll.nextPanel(null, "videoState")
                }
                $(document).trigger("VideoPlayer::ended", event.target)
                return lessonsAll.logEnded()
            }
          },
        },
      })
      $("#playerContainer").parent().fitVids()

      return (this.player = player)
    }
  }

  checkTimeline(flag, event, videoId, lessonId) {
    const self = this
    if (flag === true) {
      return (this.timer = setInterval(
        () => self.getPlayerPercentageViewed(event, videoId, lessonId),
        1200
      ))
    } else {
      return clearInterval(this.timer)
    }
  }

  getPlayerPercentageViewed(event, videoId, lessonId) {
    const currentTime = event.target.getCurrentTime()
    const videoDuration = event.target.getDuration()
    const currentViewedPercentage = Math.round(
      (currentTime / videoDuration) * 100
    )
    const currentVideoPlaybackQuality = event.target.getPlaybackQuality()

  }
}
